import { Component, OnInit } from '@angular/core';
import { UserService } from '../../api/services/user.service';
import { AuthService } from '../../api/services/auth.service';
import { Report } from '../../api/models/report';
import { PreferencesService } from '../../api/services/preferences.service';
import { MarketService } from '../../api/services/market.service';
import { Router, ActivatedRoute } from '@angular/router';
import { RoleRequest } from '../../api/models/role-assignment-map';


@Component({
  selector: 'app-dashboard-reports',
  templateUrl: './dashboard-reports.component.html',
  styleUrls: ['./dashboard-reports.component.scss']
})
export class DashboardReportsComponent implements OnInit {

  items: Report[] = [];
  itemsFiltered: Report[] = [];
  itemsToShow: Report[] = [];
  page = 1;
  pageSize = 50;
  visibleContext: boolean = false;
  noReportText = [];
  loading: boolean = true;
  roleRequest: RoleRequest;
  isTesscoAdmin: boolean = false;
  isClientAdmin: boolean = false;
  isAllowedReportView: boolean = false;
  permissionLoaded: Promise<boolean>;

  constructor( private userService: UserService,
              private router: Router, 
              private authService: AuthService,
  ) { }

  loadPage(page) {
    const from = (page - 1) * this.pageSize;
    const to = from + this.pageSize;
    this.itemsToShow =  this.itemsFiltered.slice(from, to);
  }

  setNoProjectText() {
    this.noReportText = ["No reports to show"];
  }

  setItemsList(reports) {
    this.items = reports;
    this.itemsFiltered = this.items.slice();
    this.loadPage(1);
  }

  goToOrderStatusReport(){
    this.router.navigate(['/reports', { outlets: { 'report-content': ['orderstatusreport'] } }]);
  }

  ngOnInit() {
    this.loading =false;
    this.userService.getAllReports().subscribe(reports => {
      if(reports && reports.length < 1) {
        this.setNoProjectText();
      } else {
        this.setItemsList(reports);
      }
      this.loading = false;
    });
    this.roleRequest = new RoleRequest('ADMIN_TESSCO', null);
    this.roleRequest.setRoleAndContextMap('ADMIN_CLIENT', null);
    this.roleRequest.setRoleAndContextMap('REPORT_VIEW', null);
    this.authService.getUserRoles(this.roleRequest).subscribe(roles => {
        this.isTesscoAdmin = roles.getRoleMap('ADMIN_TESSCO');
        this.isClientAdmin = roles.getRoleMap('ADMIN_CLIENT');
        this.isAllowedReportView = roles.getRoleMap('REPORT_VIEW');
        this.permissionLoaded = Promise.resolve(true);
    }, error => {
      this.permissionLoaded = Promise.resolve(true);
    });
  }

  allowReportView() : boolean {
    return this.isTesscoAdmin || this.isClientAdmin || this.isAllowedReportView;
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/dashboard-reports/dashboard-reports.component.ts